<template>
  <!--http://victorygarage.test/api/invoice?receipt=203&agent=1&created=2018-06-28T12:05:09%2B00:00,2018-06-28T13:05:09%2B00:00-->
  <div class="wrapper">
    <div class="animated fadeIn">
      <div>
        <b-modal centered v-model="active" label="Delete" v-if="invoiceToDelete">
          <div>Are you sure you want to delete Invoice Id:{{invoiceToDelete.id}} with Receipt Id: {{invoiceToDelete.receipt_id}}?</div>
          <div slot="modal-footer">
            <b-btn ref="myModalRef" variant="danger" @click="handleConfirm">Confirm</b-btn>
            <b-btn @click="handleCancel">Cancel</b-btn>
          </div>
        </b-modal>
      </div>
      <div class="invoice-list">
        <b-row class="my-2">
          <b-col md="12">
            <b-card header-tag="header">
              <div slot="header">
                <i class="fa fa-align-justify"></i> <strong>Filter</strong>
                <div class="card-actions">
                  <b-dropdown variant="link" size="sm" no-caret>
                  <template slot="button-content">
                    <i class="fa fa-ellipsis-v fa-lg" ></i>
                  </template>
                      <b-dropdown-header>Invoices</b-dropdown-header>
                      <b-dropdown-item to="/invoices/add">Add Invoice</b-dropdown-item>
                    </b-dropdown>
                </div>
              </div>
              <b-row>
                <b-col>
                  <v-text-field v-model="filters.receipt" type="number" placeholder="Receipt Number">
                    <span slot="label">Filter by Receipt Number</span>
                  </v-text-field>
                </b-col>
                <b-col>
                  <v-input-date-range
                    label='Filter Invoices by date created'
                    :from="filters.created.to"
                    @inputFrom="(from) => {filters.created.from = from}"
                    :to="filters.created.to"
                    @inputTo="(to) => {filters.created.to = to}"
                    :disabled="isBusy"></v-input-date-range>
                </b-col>
                <b-col>
                  <v-select-field
                    v-model="filters.agent"
                    :options="select2Agents"
                    name="agents"
                    placeholder="Filter by Agent">
                    <span slot="label">Filter by Agent</span>
                  </v-select-field>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
        <b-card class="p-0" no-body>
          <b-table
            stacked="lg"
            :outlined="true"
            class="border-0 m-0"
            show-empty
            responsive
            :fields="fields"
            :busy.sync="isBusy"
            :items="invoiceProvider"
            :filter="filterParams"
            :current-page="meta.current_page"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :per-page="meta.per_page"
            hover>
          <template slot="created_at" slot-scope="row">
            <div>{{row.item.created_at | moment("D/MM/YY HH:mm")}}</div>
          </template>
            <template slot="from" slot-scope="row">
            <div>{{row.item.from | moment("D/MM/YY")}}</div>
          </template>
          <template slot="to" slot-scope="row">
            <div>{{row.item.to | moment("D/MM/YY")}}</div>
          </template>
          <template slot="agent_id" slot-scope="row">
            <div v-html="getAgentNameById(row.item.agent_id)"></div>
          </template>
          <template slot="more" slot-scope="row">
            <b-dropdown variant="link" size="sm" no-caret>
              <template slot="button-content">
                <i class="fa fa-ellipsis-h fa-lg"></i>
              </template>
              <b-dropdown-header>Invoice No: {{row.item.name}}</b-dropdown-header>
              <b-dropdown-item :to="'/invoices/' + row.item.id">View Invoice</b-dropdown-item>
              <b-dropdown-item-button @click="row.toggleDetails" :disabled="!row.item.free_text">View Additional Notes</b-dropdown-item-button>
              <b-dropdown-item-button @click="confirmDelete(row.item)">Delete Invoice</b-dropdown-item-button>
            </b-dropdown>
          </template>
          <template slot="row-details" slot-scope="row">
            <b-card>
              <b-row>
                <b-col class="text-right">
                  <b-button type="generate" variant="light" size="sm" @click="row.toggleDetails">
                    <i class="fa fa-window-close"></i> Close
                  </b-button>
                </b-col>
                <b-col cols="12">
                  <div v-html="row.item.free_text"></div>
                </b-col>
              </b-row>
            </b-card>
          </template>
        </b-table>
          <div class="pagination-container p-3 border-top">
            <b-row>
              <b-col class="text-right">
                <b-pagination
                  align="right"
                  class="my-0"
                  :disabled="isBusy"
                  :total-rows="meta.total"
                  :per-page="meta.per_page"
                  v-model="meta.current_page"/>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {invoiceServices} from '../../services'

export default {
  name: 'invoices-list',
  data () {
    return {
      invoiceToDelete: null,
      active: false,
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filters: {
        receipt: null,
        agent: null,
        created: {
          to: null,
          from: null
        }
      },
      fields: [
        { key: 'receipt_id', label: 'Receipt Number', sortable: true },
        { key: 'agent_id', label: 'Agent' },
        { key: 'created_at', label: 'Date Created', sortable: true },
        { key: 'from', label: 'Bookings from' },
        { key: 'to', label: 'Bookings to' },
        { key: 'more', label: '' }
      ],
      links: {
        next: null,
        prev: null,
        first: null,
        last: null
      },
      meta: {
        current_page: null,
        from: null,
        to: null,
        last_page: null,
        path: null,
        per_page: null,
        total: null
      },
      isBusy: false
    }
  },
  computed: {
    ...mapGetters(
      'agents',
      [
        'select2Agents',
        'agentById'
      ]
    ),
    filterParams () {
      let params = {}
      if (this.filters.receipt) {
        params.receipt = parseInt(this.filters.receipt)
      }
      if (this.filters.agent) {
        params.agent = parseInt(this.filters.agent)
      }
      if (this.filters.created.from && this.filters.created.to) {
        params.created = this.filters.created.from + ',' + this.filters.created.to
      }
      return JSON.stringify(params)
    }
  },
  methods: {
    getInvoices () {
      this.isBusy = true
      let xhr = this.$store.dispatch('invoices/index')

      xhr.then(
        () => {
          this.isBusy = false
        },
        () => {
          this.isBusy = false
        }
      )
    },
    handleDeleteFail () {
      this.isBusy = false
    },
    handleConfirm () {
      let xhr = this.$store.dispatch('invoices/destroy', this.invoiceToDelete.id)
      xhr.then(this.handleDeleteSuccess).catch(this.handleDeleteFail)
    },
    handleCancel () {
      this.active = false
    },
    handleDeleteSuccess () {
      this.active = false
      this.getInvoices()
    },
    confirmDelete (invoice) {
      this.invoiceToDelete = invoice
      this.active = true
    },
    getAgentNameById (agentId) {
      let agent = this.agentById(agentId)
      return (agent) ? agent.name : '<strong class="text-danger">Agent Not Found</strong>'
    },
    setLinks (links) {
      if (links) {
        this.$set(this.links, 'first', links.first)
        this.$set(this.links, 'last', links.last)
        this.$set(this.links, 'next', links.next)
        this.$set(this.links, 'prev', links.prev)
      }
    },
    setMeta (meta) {
      if (meta) {
        this.$set(this.meta, 'current_page', meta.current_page)
        this.$set(this.meta, 'from', meta.from)
        this.$set(this.meta, 'to', meta.to)
        this.$set(this.meta, 'last_page', meta.last_page)
        this.$set(this.meta, 'path', meta.path)
        this.$set(this.meta, 'per_page', meta.per_page)
        this.$set(this.meta, 'total', meta.total)
      }
    },
    invoiceProvider () {
      let filterParams = this.filterParams
      let params = {
        ...JSON.parse(filterParams),
        page: this.meta.current_page || 1
      }

      if (this.sortBy) {
        params.sort = this.sortBy
        if (this.sortDesc) {
          params.sort = params.sort + '-'
        }
      }

      let xhr = invoiceServices.index(params)

      return xhr.then(this.handleBookingProviderSuccess, this.handleBookingProviderFail)
    },
    handleBookingProviderSuccess (res) {
      if (res.hasOwnProperty('data')) {
        this.setLinks((res.data.hasOwnProperty('links')) ? res.data.links : null)
        this.setMeta((res.data.hasOwnProperty('meta')) ? res.data.meta : null)

        return (res.data.hasOwnProperty('data')) ? res.data.data : []
      } else {
        return []
      }
    },
    handleBookingProviderFail (e) {
      console.log(e.response)
      debugger
    }
  },
  created () {
    this.$store.dispatch('agents/index')
  }
}
</script>



// WEBPACK FOOTER //
// src/views/invoices/Index.vue